const overridePropsOnMockIfApplicable = props => {
  var _props$mock, _props$mock2;
  if (props !== null && props !== void 0 && (_props$mock = props.mock) !== null && _props$mock !== void 0 && _props$mock.type && (props === null || props === void 0 ? void 0 : (_props$mock2 = props.mock) === null || _props$mock2 === void 0 ? void 0 : _props$mock2.type.toLowerCase()) === "designer") {
    if (!props.webChatContainerProps) {
      props.webChatContainerProps = {};
    }
    if (!props.webChatContainerProps.webChatProps) {
      props.webChatContainerProps.webChatProps = {};
    }
    if (!props.webChatContainerProps.webChatStyles) {
      props.webChatContainerProps.webChatStyles = {};
    }
    if (!props.webChatContainerProps.webChatProps.overrideLocalizedStrings) {
      props.webChatContainerProps.webChatProps.overrideLocalizedStrings = {};
    }
    props.webChatContainerProps = {
      ...props.webChatContainerProps,
      webChatProps: {
        disabled: true,
        ...props.webChatContainerProps.webChatProps,
        overrideLocalizedStrings: {
          TEXT_INPUT_PLACEHOLDER: "Send a message . . .",
          ...props.webChatContainerProps.webChatProps.overrideLocalizedStrings
        }
      },
      webChatStyles: {
        hideUploadButton: false,
        sendBoxBackground: "rgb(243, 242, 241)",
        ...props.webChatContainerProps.webChatStyles
      }
    };
  }
};
export default overridePropsOnMockIfApplicable;